import * as React from 'react';
import { Svg, Path } from 'react-native-svg';
import { memo } from 'react';
import type { IconProps } from '../helpers/icon-props';

const Icon = (props: IconProps) => {
  const { size = 24, ...otherProps } = props;
  return (
    <Svg width={size} height={size} viewBox="0 0 512 512" {...otherProps}>
      <Path
        d="M512 256c0 141.384-114.616 256-256 256S0 397.384 0 256C0 256.061 256 .028 256 0c141.384 0 256 114.616 256 256"
        fill="#0052b4"
      />
      <Path d="M256 0h-.043zM255.315 256H256v-.685z" fill="#f0f0f0" />
      <Path
        d="M256 133.565V0h-.043C114.591.024 0 114.629 0 256h133.565v-75.211L208.776 256h46.54l.685-.685v-46.537l-75.213-75.213z"
        fill="#f0f0f0"
      />
      <Path
        d="M129.515 33.391a257.2 257.2 0 0 0-96.124 96.124V256h66.783V100.174H256V33.391z"
        fill="#d80027"
      />
      <Path
        d="m256 224.519-90.955-90.953h-31.48v.002L255.998 256H256z"
        fill="#d80027"
      />
      <Path
        d="M289.391 133.565v122.434c0 59.64 77.913 77.914 77.913 77.914s77.913-18.274 77.913-77.914V133.565z"
        fill="#338af3"
      />
      <Path
        d="M289.391 255.999c0 59.64 77.913 77.914 77.913 77.914s77.913-18.274 77.913-77.914z"
        fill="#a2001d"
      />
      <Path d="M400.696 189.219h-22.262v-22.262h-22.261v22.262h-22.26v22.26h22.26v66.782h22.261v-66.782h22.262z" />
    </Svg>
  );
};
Icon.displayName = 'Montserrat';
export const Montserrat = memo<IconProps>(Icon);
